import { render, staticRenderFns } from "./ChatRemoveUserButton.vue?vue&type=template&id=28bebf56&"
import script from "./ChatRemoveUserButton.vue?vue&type=script&lang=js&"
export * from "./ChatRemoveUserButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports